// AWS Amplify Configuration
// These values should be populated from Terraform outputs after deployment
// You can either:
// 1. Replace these with actual values after running terraform apply
// 2. Use environment variables (recommended for production)

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_XXXXXXXXX',
      userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID || 'XXXXXXXXXXXXXXXXXXXXXXXXXX',
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_DOMAIN || 'oc-algo-dev-auth.auth.us-east-1.amazoncognito.com',
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [
            process.env.REACT_APP_REDIRECT_SIGN_IN || 'http://localhost:3000',
          ],
          redirectSignOut: [
            process.env.REACT_APP_REDIRECT_SIGN_OUT || 'http://localhost:3000',
          ],
          responseType: 'code', // Authorization code flow with PKCE
        },
        username: true,
        email: true,
      },
    },
  },
};

export default awsConfig;
